import JwtDecode from 'jwt-decode';

export default class User {
  static from(token) {
    try {
      let obj = JwtDecode(token);
      return new User(obj);
    } catch (_) {
      return null;
    }
  }

  constructor({ role, name }) {
    this.role = role;
    this.name = name;
  }

  get isAdmin() {
    return this.role;
  }
}
